module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/new/copy-e74ab7af448bb379ef59ebec2af5b77a.svg";